/* unplugin-vue-components disabled */import { render } from "./BugLine.vue.js?vue&type=template&id=156e3c4e!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./BugLine.vue?vue&type=template&id=156e3c4e"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__